import { GeoIpKeys, GeoIpState } from '../../state/reducers/geoIpReducer'

export const getGeoIpCountryCode = (state: { geoIp: GeoIpState }) =>
  state.geoIp[GeoIpKeys.geoIpCountry]

export const getGeoIpBlocked = (state: { geoIp: GeoIpState }) =>
  state.geoIp[GeoIpKeys.geoIpBlocked]
